import { Attention, Button, Typography } from "@optimizely/axiom";
import { useNavigate } from "react-router-dom";
import styles from "./warnings.module.scss";
import { useOpalBranding } from "../../../hooks/useOpalBranding/useOpalBranding";

export const GenerativeAIOrganizationSettingRequirement = () => {
    const navigate = useNavigate();
    const { opalName } = useOpalBranding();
    const goToEnable = () => {
        navigate("/settings/genai");
    };

    return (
        <Attention
            data-cy="genai-org-setting-requirement-warning"
            type="warning"
            className={`push-double--top ${styles["warnings"]}`}
        >
            <Typography type="body" tag="div">
                In order to select instances for {opalName} suggestions, you must first enable {opalName} for your
                organization in the{" "}
                <Button style="plain" className={`link no-border ${styles["warnings--contents"]}`} onClick={goToEnable}>
                    <Typography type="body">{opalName} / Organization tab.</Typography>
                </Button>
            </Typography>
        </Attention>
    );
};

GenerativeAIOrganizationSettingRequirement.displayName = "GenerativeAIOrganizationSettingRequirement";
